import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';

class Notification extends Component {
  hideNotificationBar = () => {
    this.props.onNotificationTextChange(null);
  };

  render({ notificationMsg }, {}) {
    return (
      <div className={`ptm-notify-box`}>
        <p className={`ptm-notify-txt`}>{notificationMsg}</p>
        <div
          className={`ptm-notify-btn ptm-centralized ptm-pos-a`}
          onClick={this.hideNotificationBar}
        >
          OK
        </div>
      </div>
    );
  }
}

export default connect(
  'notificationMsg',
  onChange
)(Notification);



// WEBPACK FOOTER //
// ./components/notification/index.js